import React, { useEffect, useState, useMemo, useRef } from "react";
import { Card, Form } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import uuid from "react-uuid";
import { 
  DateHelper, FormHelper, 
  TIPO_NOTAS_CANCELACION, 
  ESTADO_ECF_ACEPTADO, ESTADO_ECF_ACEPTADO_LABEL, 
  ESTADO_ECF_ACEPTADO_CONDICIONAL_LABEL, ESTADO_ECF_ACEPTADO_CONDICIONAL } from "utils";
import { Permisos } from "utils/permisos";
import { CurrencyInput } from "components/PantallasEdit/CurrencyInput/CurrencyInput";
import { GridView, ItemLookup, ClienteLookup, TransaccionesLookup, SvgComponent, RncLookup } from "components";
import EditHeader from "components/PantallasEdit/Header/EditHeader";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import EditContainer from "components/PantallasEdit/EditContainer/EditContainer";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";
import EditSection from "components/PantallasEdit/EditSection/EditSection";
import { DateTimePicker } from "components/DateTimePicker/DateTimePicker";
import IconButton from "components/IconButton/IconButton";
import ToolTip from "components/ToolTip/ToolTip";
import ReporteViewer from "components/Reportes/ReporteViewer";
import { AnimatedIconButton } from "components/AnimatedIconButton/AnimatedIconButton";
import ModalContainer from "components/ModalContainer/ModalContainer";
import { useAuthentication } from "hooks"
import useMessage from "hooks/useMessage";
import useExceptionHandler from "hooks/useExceptionHandler";
import useQueryParams from "hooks/useQueryParams";
import { TransaccionesManager } from "managers";
import { CondicionPagoManager } from "managers";
import {
  eCF,
  TIPO_COMPROBANTE_FACTURA_CREDITO_FISCAL,
  TIPO_COMPROBANTE_FACTURA_CONSUMO,
  TIPO_COMPROBANTE_NOTA_DEBITO,
  TIPO_COMPROBANTE_NOTA_CREDITO,
  TIPO_COMPROBANTE_COMPRAS,
  TIPO_COMPROBANTE_GASTO_MENOR,
  TIPO_COMPROBANTE_REGIMEN_ESPECIAL,
  TIPO_COMPROBANTE_GUBERNAMENTAL,
  TIPO_COMPROBANTE_EXPORTACIONES,
  TIPO_COMPROBANTE_PAGOS_EXTERIOR,
  TIPO_PAGO_CREDITO,
  MONEDA_PESO_DOMINICANO_ISO,
  TIPO_DESCUENTO_RECARGO_MONTO,
  TIPO_DESCUENTO_RECARGO_PORCENTAJE,
} from "models/ECF/ECF";
import { Cliente } from "models/ECF/Cliente";

export default function TransaccionesEdit({ showLoading, hideLoading }) {
  const history = useHistory();
  const URLParameters = useQueryParams();
  const Id = URLParameters.get("Id");
  const isReadonly = !!Id;
  const [transaccion, setTransaccion] = useState({});
  const { usuario, tienePermiso } = useAuthentication();
  const [detalles, setDetalles] = useState([]);
  const [itemSeleccionado, setItemSeleccionado] = useState({});
  const [descuentoGlobalSeleccionado, setDescuentoGlobalSeleccionado] = useState({});
  const [showSubDescuentoModal, setShowSubDescuentoModal] = useState(false);
  const [indiceDetalleParaDescuento, setIndiceDetalleParaDescuento] = useState(null);
  const [subDescuentoSeleccionado, setSubDescuentoSeleccionado] = useState({});
  const [clienteSeleccionado, setClienteSeleccionado] = useState({});
  const clienteLookupRef = useRef(null);
  const [ncfModificadoSeleccionado, setNcfModificadoSeleccionado] = useState({});
  const [tituloHeader, setTituloHeader] = useState("Emitir E-CF");
  const { Message, Warning, cerrarAlertas } = useMessage();
  const { handleException } = useExceptionHandler();
  const [reporte, setReporte] = useState(null);
  const [showCanvasReporte, setShowCanvasReporte] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showCancelarModal, setShowCancelarModal] = useState(false);
  const [cancelacionData, setCancelacionData] = useState({});
  const [pagination, setPagination] = useState({
    EsPaginable: false,
  });

  const [condicionesDePago, setCondicionesDePago] = useState([]);
  const [condicionPagoSeleccionada, setCondicionPagoSeleccionada] = useState(null);
  const [fechaVencimientoSecuenciaFilterkey, setFechaVencimientoSecuenciaFilterkey] = useState(uuid());
  const [fechaEmisionFilterkey, setFechaEmisionFilterkey] = useState(uuid());
  const [fechaLimitePagoFilterkey, setFechaLimitePagoFilterkey] = useState(uuid());
  const [fechaNcfModificadoFilterkey, setFechaNcfModificadoFilterkey] = useState(uuid());
  const [itemLookupKey, setItemLookupKey] = useState(uuid());

  useEffect(() => {
    cerrarAlertas();
    CondicionPagoManager
      .listado({ EsPaginable: false, NoEstatus: "I" })
      .then((res) => setCondicionesDePago(res.Data ?? []))
      .catch(() => {});

    if (Id) {
      setTituloHeader("Ver E-CF");
      TransaccionesManager
        .verPorId(Id)
        .then((res) => {
          const data = res.Data ?? res;

          const descuentos = data.DescuentosRecargos ?? [];
          const TipoDescuentoGlobal = descuentos.length > 0 ? TIPO_DESCUENTO_RECARGO_MONTO : null;
          const DescuentoGlobal = descuentos.length > 0
            ? descuentos.reduce((sum, d) => sum + (d.MontoDescuentooRecargo ?? 0), 0)
            : null;
          setTransaccion({
            ...data,
            DocumentoComprador: data.RNCComprador ?? data.IdentificadorExtranjero,
            EstadoECF: data.EstadoECF ?? data.EstadoeCF,
            eCFCancelado: data.eCFCancelado,
            eNCF: data.eNCF,
            CorreoComprador: data.CorreoComprador,
            TipoDescuentoGlobal,
            DescuentoGlobal,
          });

          setDetalles((data.DetallesItem ?? []).map((item) => ({
            ...item,
            Nombre: item.NombreItem,
            Cantidad: item.CantidadItem,
            PrecioUnitario: item.PrecioUnitarioItem,
            IndicadorBienOServicio: item.IndicadorBienoServicio,
          })));
        })
        .catch(handleException)
        .finally(hideLoading);
    } else {
      setDefaultValues();
      hideLoading();
    }
  }, []);

  const setDefaultValues = () => {
    setTransaccion({
      TipoMoneda: MONEDA_PESO_DOMINICANO_ISO,
      FechaEmision: DateHelper.formatDate(new Date()),
    });
  };

  function grabar() {
    showLoading();

    const { TipoDescuentoGlobal, DescuentoGlobal, ...transaccionBase } = transaccion;

    const request = {
      ...transaccionBase,
      DescuentosRecargos: TipoDescuentoGlobal && DescuentoGlobal
        ? [{
          NumeroLinea: 1,
          TipoAjuste: "D",
          TipoValor: TipoDescuentoGlobal,
          DescripcionDescuentooRecargo: "Descuento",
          ValorDescuentooRecargo: TipoDescuentoGlobal === TIPO_DESCUENTO_RECARGO_PORCENTAJE ? DescuentoGlobal : null,
          MontoDescuentooRecargo: TipoDescuentoGlobal === TIPO_DESCUENTO_RECARGO_MONTO ? DescuentoGlobal : null,
        }]
        : [],
      DetallesItem: detalles.map((d, index) => ({
        NumeroLinea: index + 1,
        ItemId: d.value,
        NombreItem: d.Nombre,
        IndicadorFacturacion: d.IndicadorFacturacion,
        IndicadorBienoServicio: d.IndicadorBienOServicio,
        PrecioUnitarioItem: d.PrecioUnitario,
        PrecioUnitarioReferencia: d.PrecioUnitarioReferencia,
        CantidadItem: d.Cantidad ?? d.CantidadItem,
        MontoITBISRetenido: d.TotalRetencionItbis ?? d.MontoITBISRetenido ?? 0,
        MontoISRRetenido: d.TotalRetencionIsr ?? d.MontoISRRetenido ?? 0,
        SubDescuentos: d.SubDescuentos || [],
      })),
    };

    TransaccionesManager.crearECF(request)
      .then((_res) => {
        Message({ message: `Grabado Exitosamente` });
        history.push("/TransaccionesList");
      })
      .catch((e) => handleException(e))
      .finally(() => hideLoading());
  }

  const representacionImpresa = (IdSec) => {
    showLoading();
    TransaccionesManager
      .representacionImpresa(IdSec)
      .then((res) => {
        setReporte(res.Data);
        setShowCanvasReporte(true);
      })
      .catch((err) => {
        handleException(err);
      })
      .finally(() => hideLoading());
  };

  const descargarArchivoXML = () => {
    showLoading();
    TransaccionesManager
      .descargarArchivoXML(Id)
      .then((res) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(res);
        link.download = `${transaccion.eNCF}.xml`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err) => handleException(err))
      .finally(() => hideLoading());
  };

  const descargarArchivoRespuestaXML = () => {
    showLoading();
    TransaccionesManager
      .descargarArchivoRespuestaXML(Id)
      .then((res) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(res);
        link.download = `${transaccion.eNCF}_respuesta.xml`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err) => handleException(err))
      .finally(() => hideLoading());
  };

  const abrirLinkQR = () => {
    showLoading();
    TransaccionesManager
      .visualizarLinkQR(Id)
      .then((res) => window.open(res.Data.url, "_blank"))
      .catch((err) => handleException(err))
      .finally(() => hideLoading());
  };

  const handleEmailClick = () => setShowEmailModal(true);

  const enviarRepresentacionEmail = () => {
    showLoading();
    TransaccionesManager
      .enviarEmail(Id, transaccion.CorreoComprador)
      .then(() => {
        setShowEmailModal(false);
        Message({ message: "Email enviado Exitosamente." });
      })
      .catch((err) => handleException(err))
      .finally(() => hideLoading());
  };

  const handleCancelarClick = () => {
    if (transaccion.eCFCancelado) {
      Warning({ message: "Ya fue generada una Nota de Cancelación para este comprobante." });
      return;
    }
    setCancelacionData({
      TipoNotaCancelacion: transaccion.eNCF?.startsWith("E34")
        ? TIPO_COMPROBANTE_NOTA_DEBITO
        : TIPO_COMPROBANTE_NOTA_CREDITO,
      fechaEmisionCancelacion: new Date(),
      fechaVencimientoSecuenciaCancelacion: new Date(new Date().getFullYear(), 11, 31, 23, 59, 59, 999),
    });
    if (
      transaccion.EstadoECF == ESTADO_ECF_ACEPTADO ||
      transaccion.EstadoECF == ESTADO_ECF_ACEPTADO_CONDICIONAL
    ) {
      setShowCancelarModal(true);
    } else {
      Warning({ message: `Para generar Nota de Cancelación el comprobante debe ser ${ESTADO_ECF_ACEPTADO_LABEL}.` });
    }
  };

  const cancelarECF = () => {
    showLoading();
    TransaccionesManager
      .cancelarECF({
        TransaccionId: Id,
        fechaEmisionCancelacion: cancelacionData.fechaEmisionCancelacion,
        TipoNota: cancelacionData.TipoNotaCancelacion,
        NCFCancelacion: cancelacionData.NCFCancelacion,
        FechaVencimientoSecuenciaCancelacion: cancelacionData.fechaVencimientoSecuenciaCancelacion,
      })
      .then((res) => {
        if (
          res.Data.EstadoeCF != ESTADO_ECF_ACEPTADO_LABEL &&
          res.Data.EstadoeCF != ESTADO_ECF_ACEPTADO_CONDICIONAL
        ) {
          Warning({ message: res.Data.Mensaje });
          return;
        }
        Message({ message: "Nota de Cancelación generada Exitosamente." });
        setShowCancelarModal(false);
      })
      .catch((err) => handleException(err))
      .finally(() => hideLoading());
  };

  const handleVolverClick = () => {
    const urlBase = `/TransaccionesList`;
    history.push(urlBase);
  };

  const handleEliminarDetalle = (indiceAEliminar) => {
    const nuevosDetalles = detalles.filter((_, indice) => indice !== indiceAEliminar);
    setDetalles(nuevosDetalles);
  };

  const handleDetalleChange = (index, event) => {
    const nuevosDetalles = [...detalles];
    const { name, value } = event.target;

    nuevosDetalles[index][name] = value;

    setDetalles(nuevosDetalles);
  };

  const montoTotal = useMemo(() => {
    return detalles
      .filter(item => item.IndicadorFacturacion !== 0)
      .reduce(
        (acc, item) => acc + ((item.PrecioUnitario || 0) * (item.Cantidad || 0)),
        0
      );
  }, [detalles]);

  const totalITBISRetenido = useMemo(() => {
    return detalles
      .filter(item => item.IndicadorFacturacion !== 0 && item.IndicadorFacturacion !== 3 && item.IndicadorFacturacion !== 4)
      .reduce(
        (acc, item) => acc + (item.MontoITBISRetenido || 0),
        0
      );
  }, [detalles]);

  const totalISRRetenido = useMemo(() => {
    return detalles
      .filter(item => item.IndicadorFacturacion !== 0)
      .reduce(
        (acc, item) => acc + (item.MontoISRRetenido || 0),
        0
      );
  }, [detalles]);

  const esNotaDebito = transaccion.TipoeCF === TIPO_COMPROBANTE_NOTA_DEBITO;
  const esNotaCredito = transaccion.TipoeCF === TIPO_COMPROBANTE_NOTA_CREDITO;

  const handleAbrirSubDescuentoModal = (index) => {
    setIndiceDetalleParaDescuento(index);
    setSubDescuentoSeleccionado({});
    setShowSubDescuentoModal(true);
  };

  const handleCerrarSubDescuentoModal = () => {
    setShowSubDescuentoModal(false);
    setIndiceDetalleParaDescuento(null);
    setSubDescuentoSeleccionado({});
  };

  const handleAgregarSubDescuentoClick = () => {
    if (indiceDetalleParaDescuento === null || !subDescuentoSeleccionado.TipoSubDescuento) return;
    const nuevosDetalles = [...detalles];
    nuevosDetalles[indiceDetalleParaDescuento] = {
      ...nuevosDetalles[indiceDetalleParaDescuento],
      SubDescuentos: [subDescuentoSeleccionado],
    };
    setDetalles(nuevosDetalles);
    handleCerrarSubDescuentoModal();
  };

  const handleEliminarSubDescuento = () => {
    if (indiceDetalleParaDescuento === null) return;
    const tipoSubDescuento = detalles[indiceDetalleParaDescuento]?.SubDescuentos?.[0]?.TipoSubDescuento;
    const nuevosDetalles = [...detalles];
    nuevosDetalles[indiceDetalleParaDescuento] = {
      ...nuevosDetalles[indiceDetalleParaDescuento],
      SubDescuentos: [],
    };
    setDetalles(nuevosDetalles);
    setSubDescuentoSeleccionado({ TipoSubDescuento: tipoSubDescuento });
  };

  const handleAgregarDescuentoClick = () => {
    if (descuentoGlobalSeleccionado.TipoDescuentoGlobal) {
      setTransaccion({
        ...transaccion,
        TipoDescuentoGlobal: descuentoGlobalSeleccionado.TipoDescuentoGlobal,
        DescuentoGlobal: descuentoGlobalSeleccionado.DescuentoGlobal,
      });
    }
    setDescuentoGlobalSeleccionado({});
  };

  const handleAgregarItemClick = () => {
    if (itemSeleccionado && itemSeleccionado.value) {
      const cantidadAgregada = itemSeleccionado.Cantidad > 0 ? itemSeleccionado.Cantidad : 1;
      const precio = itemSeleccionado.PrecioUnitario > 0 ? itemSeleccionado.PrecioUnitario : 0.00;
      const nuevoDetalle = {
        ...itemSeleccionado,
        IdSec: itemSeleccionado.value,
        Cantidad: cantidadAgregada,
        CantidadItem: cantidadAgregada,
        PrecioUnitarioReferencia: precio,
        MontoITBISRetenido: 0,
        MontoISRRetenido: 0,
        SubDescuentos: [],
      };

      setDetalles([...detalles, nuevoDetalle]);
    }
    setItemSeleccionado({});
    setItemLookupKey(uuid());
  };

  const subDescuentoModal = (
    <ModalContainer
      showModal={showSubDescuentoModal}
      cerrar={handleCerrarSubDescuentoModal}
      grabar={() => { }}
      title="Descuento de Item"
      subtitle={indiceDetalleParaDescuento !== null ? detalles[indiceDetalleParaDescuento]?.Nombre : ""}
      size="lg"
      btnGrabar={{ show: false }}
      btnCerrar={{ show: true, label: "Cerrar" }}
    >
      {indiceDetalleParaDescuento !== null && (() => {
        const descuentoAplicado = detalles[indiceDetalleParaDescuento]?.SubDescuentos?.[0];

        if (descuentoAplicado) {
          return (
            <SectionRow triple={true}>
              <InputContainer stacked label="Tipo de Descuento">
                <Form.Control
                  readOnly
                  value={eCF.TIPOS_DESCUENTOS.find(o => o.value === descuentoAplicado.TipoSubDescuento)?.label ?? ""}
                />
              </InputContainer>

              <InputContainer stacked label={descuentoAplicado.TipoSubDescuento === TIPO_DESCUENTO_RECARGO_MONTO ? "Monto" : "Porcentaje"}>
                <CurrencyInput
                  readOnly
                  value={descuentoAplicado.TipoSubDescuento === TIPO_DESCUENTO_RECARGO_MONTO
                    ? descuentoAplicado.MontoSubDescuento
                    : descuentoAplicado.SubDescuentoPorcentaje
                  }
                />
              </InputContainer>

              {!isReadonly && (
                <InputContainer stacked label=" ">
                  <IconButton onClick={handleEliminarSubDescuento}>
                    <ToolTip message="Eliminar descuento">
                      <div>
                        <SvgComponent iconName="trash" height="25" width="25" />
                      </div>
                    </ToolTip>
                  </IconButton>
                </InputContainer>
              )}
            </SectionRow>
          );
        }

        const montoOk = subDescuentoSeleccionado.TipoSubDescuento === TIPO_DESCUENTO_RECARGO_MONTO
          && subDescuentoSeleccionado.MontoSubDescuento && (subDescuentoSeleccionado.MontoSubDescuento > 0);
        const porcentajeOk = subDescuentoSeleccionado.TipoSubDescuento === TIPO_DESCUENTO_RECARGO_PORCENTAJE
          && subDescuentoSeleccionado.SubDescuentoPorcentaje && (subDescuentoSeleccionado.SubDescuentoPorcentaje > 0);
        const puedeAgregar = montoOk || porcentajeOk;

        return (
          <SectionRow triple={true}>
            <InputContainer stacked label="Tipo de Descuento">
              <Select
                className="react-select primary"
                classNamePrefix="react-select"
                options={eCF.TIPOS_DESCUENTOS}
                value={eCF.TIPOS_DESCUENTOS.filter(o => o.value === subDescuentoSeleccionado.TipoSubDescuento)}
                onChange={(e) => setSubDescuentoSeleccionado({
                  TipoSubDescuento: e.value,
                  MontoSubDescuento: null,
                  SubDescuentoPorcentaje: null,
                })}
              />
            </InputContainer>

            {subDescuentoSeleccionado.TipoSubDescuento && (
              <InputContainer stacked label="Descuento">
                {subDescuentoSeleccionado.TipoSubDescuento === TIPO_DESCUENTO_RECARGO_MONTO && (
                  <CurrencyInput
                    name="MontoSubDescuento"
                    value={subDescuentoSeleccionado.MontoSubDescuento ?? ""}
                    onChange={(numericValue) => setSubDescuentoSeleccionado({
                      ...subDescuentoSeleccionado,
                      MontoSubDescuento: numericValue
                    })}
                  />
                )}

                {subDescuentoSeleccionado.TipoSubDescuento === TIPO_DESCUENTO_RECARGO_PORCENTAJE && (
                  <CurrencyInput
                    name="SubDescuentoPorcentaje"
                    value={subDescuentoSeleccionado.SubDescuentoPorcentaje ?? ""}
                    onChange={(numericValue) => setSubDescuentoSeleccionado({
                      ...subDescuentoSeleccionado,
                      SubDescuentoPorcentaje: numericValue
                    })}
                  />
                )}
              </InputContainer>
            )}

            {puedeAgregar && (
              <InputContainer stacked label=" ">
                <AnimatedIconButton
                  size="38px"
                  height="20px"
                  width="20px"
                  iconName="create"
                  message="Agregar"
                  onClick={handleAgregarSubDescuentoClick}
                />
              </InputContainer>
            )}
          </SectionRow>
        );
      })()}
    </ModalContainer>
  )

  return (
    <>
      <Form action="" className="form-horizontal" method="">
        <Card>
          <EditHeader
            titulo={tituloHeader}
            {...(!isReadonly && { grabar: () => grabar() })}
            {...(isReadonly && {
              imprimirRepresentacion: () => representacionImpresa(Id),
              descargarArchivoXML: () => descargarArchivoXML(),
              descargarArchivoRespuestaXML: () => descargarArchivoRespuestaXML(),
              enviarEmail: () => handleEmailClick(),
              ...(tienePermiso(Permisos.Transacciones.CANCELAR) && { cancelarECF: () => handleCancelarClick() }),
              ...(tienePermiso(Permisos.Transacciones.VISUALIZAR_LINK_QR) && { abrirLinkQR: () => abrirLinkQR() }),
            })}
            volver={true}
            volverFunc={handleVolverClick}
          />

          <ReporteViewer
            showCanvas={showCanvasReporte}
            setShowCanvas={setShowCanvasReporte}
            reporte={reporte}
          >
          </ReporteViewer>

          <EditContainer disabled={isReadonly}>
            <EditSection title="Información General">
              <SectionRow triple={true}>
                <InputContainer stacked label="Tipo de Comprobante" required={true}>
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    isDisabled={isReadonly}
                    name="TipoeCF"
                    options={eCF.TIPOS_COMPROBANTES}
                    value={eCF.TIPOS_COMPROBANTES.filter(
                      (option) => option.value === transaccion.TipoeCF
                    )}
                    onChange={(e) => {
                      setTransaccion({
                        ...transaccion,
                        TipoeCF: e.value,
                      });
                    }}
                  />
                </InputContainer>
              </SectionRow>

              {(!usuario?.Compania?.UsaSerieFiscal || isReadonly) && (
                <SectionRow triple={true}>
                  <InputContainer stacked label="e-NCF" required={true}>
                    <Form.Control
                      type="text"
                      name="eNCF"
                      value={transaccion.eNCF}
                      onChange={(e) => FormHelper.handleChange(e, setTransaccion)}
                    />
                  </InputContainer>

                  {transaccion.TipoeCF !== TIPO_COMPROBANTE_FACTURA_CONSUMO && transaccion.TipoeCF !== TIPO_COMPROBANTE_NOTA_CREDITO && (
                    <InputContainer stacked label="Fecha de Vencimiento de la Secuencia" required={true}>
                      <DateTimePicker
                        key={fechaVencimientoSecuenciaFilterkey}
                        usarLabel={false}
                        esRangoFechas={false}
                        disabled={isReadonly}
                        soloFecha
                        fechaInicioOriginal={transaccion.FechaVencimientoSecuencia || ""}
                        onChange={(e) => {
                          setTransaccion({
                            ...transaccion,
                            FechaVencimientoSecuencia: DateHelper.formatDate(e.fechaInicio),
                          });
                        }}
                      />
                    </InputContainer>
                  )}
                </SectionRow>
              )}

              <SectionRow triple={true}>
                <InputContainer stacked label="Fecha de Emisión" required={true}>
                  <DateTimePicker
                    key={fechaEmisionFilterkey}
                    usarLabel={false}
                    esRangoFechas={false}
                    disabled={isReadonly}
                    soloFecha
                    fechaInicioOriginal={transaccion.FechaEmision}
                    onChange={(e) => {
                      setTransaccion({
                        ...transaccion,
                        FechaEmision: DateHelper.formatDate(e.fechaInicio),
                      });
                    }}
                  />
                </InputContainer>

                {transaccion.TipoeCF != TIPO_COMPROBANTE_COMPRAS && transaccion.TipoeCF != TIPO_COMPROBANTE_GASTO_MENOR && transaccion.TipoeCF != TIPO_COMPROBANTE_PAGOS_EXTERIOR && (
                  <InputContainer stacked label="Tipo de Ingresos" required={true}>
                    <Select
                      className="react-select primary"
                      classNamePrefix="react-select"
                      isDisabled={isReadonly}
                      name="TipoIngresos"
                      options={eCF.TIPOS_INGRESOS}
                      value={eCF.TIPOS_INGRESOS.filter(
                        (option) => option.value === transaccion.TipoIngresos
                      )}
                      onChange={(e) => {
                        setTransaccion({
                          ...transaccion,
                          TipoIngresos: e.value
                        });
                      }}
                    />
                  </InputContainer>
                )}
              </SectionRow>

              {transaccion.TipoeCF != TIPO_COMPROBANTE_GASTO_MENOR && transaccion.TipoeCF != TIPO_COMPROBANTE_PAGOS_EXTERIOR && (
                <SectionRow triple={true}>
                  <InputContainer stacked label="Tipo de Pago" required={transaccion.TipoeCF != TIPO_COMPROBANTE_GASTO_MENOR &&
                    transaccion.TipoeCF != TIPO_COMPROBANTE_PAGOS_EXTERIOR
                  }>
                    <RadioGroup
                      options={eCF.TIPOS_PAGOS}
                      selectedOption={transaccion.TipoPago}
                      onChange={(e) => {
                        setTransaccion({
                          ...transaccion,
                          TipoPago: e.target.value,
                          FechaLimitePago: null
                        });
                        setCondicionPagoSeleccionada(null);
                      }}
                    />
                  </InputContainer>

                  {transaccion.TipoeCF !== TIPO_COMPROBANTE_GASTO_MENOR && transaccion.TipoPago === TIPO_PAGO_CREDITO && (
                    <InputContainer stacked label="Fecha Límite de Pago" required={transaccion.TipoPago === TIPO_PAGO_CREDITO}>
                      {condicionesDePago.length > 0 ? (
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          isDisabled={isReadonly}
                          placeholder="Seleccionar condición de pago..."
                          isClearable
                          options={condicionesDePago.map((c) => ({
                            value: c.IdSec,
                            label: `${c.Descripcion}`,
                            Dias: c.Dias,
                          }))}
                          value={condicionPagoSeleccionada}
                          onChange={(selected) => {
                            setCondicionPagoSeleccionada(selected);
                            if (selected && transaccion.FechaEmision) {
                              const fechaBase = new Date(transaccion.FechaEmision);
                              fechaBase.setDate(fechaBase.getDate() + selected.Dias);
                              setFechaLimitePagoFilterkey(uuid());
                              setTransaccion({
                                ...transaccion,
                                FechaLimitePago: DateHelper.formatDate(fechaBase),
                              });
                            } else {
                              setTransaccion({ ...transaccion, FechaLimitePago: null });
                            }
                          }}
                        />
                      ) : (
                        <DateTimePicker
                          key={fechaLimitePagoFilterkey}
                          usarLabel={false}
                          esRangoFechas={false}
                          disabled={isReadonly}
                          soloFecha={true}
                          fechaInicioOriginal={transaccion.FechaLimitePago}
                          onChange={(e) => {
                            setTransaccion({
                              ...transaccion,
                              FechaLimitePago: DateHelper.formatDate(e.fechaInicio),
                            });
                          }}
                        />
                      )}
                    </InputContainer>
                  )}
                </SectionRow>
              )}

              {transaccion.TipoeCF != TIPO_COMPROBANTE_GASTO_MENOR && (
                <>
                  <SectionRow triple={true}>
                    {!isReadonly && (
                      <InputContainer stacked label="Cliente" onLabelClick={() => clienteLookupRef.current?.openClienteEdit()}>
                        <ClienteLookup
                          ref={clienteLookupRef}
                          isMultiselect={false}
                          initialValue={clienteSeleccionado}
                          onChange={(cliente) => {
                            if (cliente && cliente.value) {
                              setClienteSeleccionado(cliente);

                              const transaccionActualizada = {
                                ...transaccion
                              };

                              transaccionActualizada["TipoDocumentoComprador"] = cliente.TipoDocumento;
                              transaccionActualizada["DocumentoComprador"] = cliente.Documento;
                              transaccionActualizada["RazonSocialComprador"] = cliente.RazonSocial;

                              setTransaccion(transaccionActualizada);
                            }
                            else {
                              setClienteSeleccionado({});
                              setTransaccion({
                                ...transaccion,
                                TipoDocumentoComprador: "",
                                DocumentoComprador: "",
                                RazonSocialComprador: ""
                              });
                            }
                          }}
                        />
                      </InputContainer>
                    )}
                  </SectionRow>

                  {!isReadonly && (
                    <SectionRow triple={true}>
                      <InputContainer stacked label="Tipo Documento">
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          name="TipoDocumentoComprador"
                          options={Cliente.TIPO_DOCUMENTO_LIST}
                          value={
                            transaccion.TipoDocumentoComprador
                              ? Cliente.TIPO_DOCUMENTO_LIST.find(
                                (option) => option.value === transaccion.TipoDocumentoComprador
                              )
                              : null
                          }
                          onChange={(selectedOption) => {
                            setTransaccion({
                              ...transaccion,
                              TipoDocumentoComprador: selectedOption ? selectedOption.value : "",
                            });
                          }}
                          placeholder="Seleccione Tipo de Documento"
                          isClearable
                        />
                      </InputContainer>
                    </SectionRow>
                  )}

                  <SectionRow triple={true}>
                    <InputContainer stacked label="Documento Comprador">
                      <RncLookup
                        disabled={isReadonly}
                        initialValue={{
                          value: transaccion.DocumentoComprador ?? "",
                          label: transaccion.DocumentoComprador ?? "",
                          Rnc: transaccion.DocumentoComprador ?? "",
                          RazonSocial: transaccion.RazonSocialComprador ?? "",
                        }}
                        onChange={(e) => {
                          setTransaccion({
                            ...transaccion,
                            DocumentoComprador: e.Rnc,
                            RazonSocialComprador: e.RazonSocial,
                          });
                        }}
                      />
                    </InputContainer>

                    <InputContainer stacked label="Razón Social Comprador" required={transaccion.TipoeCF === TIPO_COMPROBANTE_FACTURA_CREDITO_FISCAL ||
                      transaccion.TipoeCF === TIPO_COMPROBANTE_COMPRAS ||
                      transaccion.TipoeCF === TIPO_COMPROBANTE_REGIMEN_ESPECIAL ||
                      transaccion.TipoeCF === TIPO_COMPROBANTE_GUBERNAMENTAL ||
                      transaccion.TipoeCF === TIPO_COMPROBANTE_EXPORTACIONES
                    }>
                      <Form.Control
                        type="text"
                        name="RazonSocialComprador"
                        value={transaccion.RazonSocialComprador}
                        onChange={(e) => FormHelper.handleChange(e, setTransaccion)}
                      />
                    </InputContainer>
                  </SectionRow>
                </>
              )}

              <SectionRow triple={true}>
                <InputContainer stacked label="Moneda">
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    isDisabled={isReadonly}
                    name="TipoMoneda"
                    options={eCF.MONEDAS}
                    value={eCF.MONEDAS.filter(
                      (option) => option.value === (transaccion.TipoMoneda ?? eCF.MONEDAS[0].value)
                    )}
                    onChange={(e) => {
                      setTransaccion({
                        ...transaccion,
                        TipoMoneda: e.value
                      });
                    }}
                  />
                </InputContainer>

                {(transaccion.TipoMoneda ?? MONEDA_PESO_DOMINICANO_ISO) !== MONEDA_PESO_DOMINICANO_ISO && (
                  <InputContainer stacked label="Tasa de Cambio" required={(transaccion.TipoMoneda ?? MONEDA_PESO_DOMINICANO_ISO) !== MONEDA_PESO_DOMINICANO_ISO}>
                    <CurrencyInput
                      name="TipoCambio"
                      placeholder="Tasa de Cambio"
                      value={transaccion.TipoCambio}
                      onChange={(numericValue) => {
                        setTransaccion({
                          ...transaccion,
                          TipoCambio: numericValue,
                        });
                      }}
                    />
                  </InputContainer>
                )}
              </SectionRow>

              <SectionRow triple={true}>
                <InputContainer stacked label="Número de Factura Interna">
                  <Form.Control
                    type="text"
                    name="NumeroFacturaInterna"
                    value={transaccion.NumeroFacturaInterna}
                    onChange={(e) => {
                      setTransaccion({
                        ...transaccion,
                        NumeroFacturaInterna: e.target.value
                      });
                    }}
                  />
                </InputContainer>
              </SectionRow>
            </EditSection>

            <EditSection title="Información de Referencia">
              <SectionRow triple={true}>
                <InputContainer stacked label="NCF Modificado" required={esNotaDebito || esNotaCredito}>
                  <TransaccionesLookup
                    disabled={isReadonly}
                    isMultiselect={false}
                    initialValue={ncfModificadoSeleccionado}
                    onChange={(selected) => {
                      if (selected && selected.value) {
                        setNcfModificadoSeleccionado(selected);

                        let fecha = null;
                        if (selected.Fecha) {
                          const [day, month, year] = selected.Fecha.trim().split('/').map(Number);
                          fecha = new Date(year, month - 1, day);
                        }

                        setFechaNcfModificadoFilterkey(uuid());
                        setTransaccion({
                          ...transaccion,
                          NCFModificado: selected.ENCF,
                          FechaNCFModificado: fecha,
                        });
                      } else {
                        setNcfModificadoSeleccionado({});
                        setFechaNcfModificadoFilterkey(uuid());
                        setTransaccion({
                          ...transaccion,
                          NCFModificado: "",
                          FechaNCFModificado: null,
                        });
                      }
                    }}
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow triple={true}>
                <InputContainer stacked label="Fecha NCF Modificado" required={esNotaDebito || esNotaCredito}>
                  <DateTimePicker
                    key={fechaNcfModificadoFilterkey}
                    usarLabel={false}
                    esRangoFechas={false}
                    disabled={isReadonly}
                    soloFecha={true}
                    fechaInicioOriginal={transaccion.FechaNCFModificado}
                    onChange={(e) => {
                      setTransaccion({
                        ...transaccion,
                        FechaNCFModificado: DateHelper.formatDate(e.fechaInicio),
                      });
                    }}
                  />
                </InputContainer>

                <InputContainer stacked label="Código de Modificación" required={esNotaDebito || esNotaCredito}>
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    isDisabled={isReadonly}
                    name="CodigoModificacion"
                    options={eCF.CODIGOS_MODIFICACION}
                    value={eCF.CODIGOS_MODIFICACION.filter(
                      (option) => option.value === transaccion.CodigoModificacion
                    )}
                    onChange={(e) => {
                      setTransaccion({
                        ...transaccion,
                        CodigoModificacion: e.value
                      });
                    }}
                  />
                </InputContainer>
              </SectionRow>
            </EditSection>

            {transaccion.TipoeCF !== TIPO_COMPROBANTE_GASTO_MENOR && transaccion.TipoeCF !== TIPO_COMPROBANTE_PAGOS_EXTERIOR && (
              <EditSection title="Descuento">
                {transaccion.TipoDescuentoGlobal ? (
                  <SectionRow triple={true}>
                    <InputContainer stacked label="Tipo descuento">
                      <Form.Control
                        readOnly
                        value={eCF.TIPOS_DESCUENTOS.find(o => o.value === transaccion.TipoDescuentoGlobal)?.label ?? ""}
                      />
                    </InputContainer>

                    <InputContainer stacked label="Descuento">
                      <CurrencyInput
                        readOnly
                        value={transaccion.DescuentoGlobal ?? 0}
                        onChange={() => { }}
                      />
                    </InputContainer>

                    {!isReadonly && (
                      <InputContainer>
                        <IconButton
                          onClick={() => {
                            setTransaccion({
                              ...transaccion,
                              TipoDescuentoGlobal: null,
                              DescuentoGlobal: null,
                            });
                            setDescuentoGlobalSeleccionado({});
                          }}
                        >
                          <ToolTip message="Eliminar descuento">
                            <div>
                              <SvgComponent iconName="trash" height="25" width="25" />
                            </div>
                          </ToolTip>
                        </IconButton>
                      </InputContainer>
                    )}
                  </SectionRow>
                ) : (
                  <SectionRow triple={true}>
                    <InputContainer stacked label="Tipo descuento">
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        isDisabled={isReadonly}
                        name="TipoDescuentoGlobal"
                        options={eCF.TIPOS_DESCUENTOS}
                        value={eCF.TIPOS_DESCUENTOS.filter(
                          (option) => option.value === descuentoGlobalSeleccionado.TipoDescuentoGlobal
                        )}
                        onChange={(e) => {
                          setDescuentoGlobalSeleccionado({
                            ...descuentoGlobalSeleccionado,
                            TipoDescuentoGlobal: e.value,
                          });
                        }}
                      />
                    </InputContainer>

                    <InputContainer stacked label="Descuento">
                      <CurrencyInput
                        name="DescuentoGlobal"
                        value={descuentoGlobalSeleccionado.DescuentoGlobal ?? 0}
                        onChange={(numericValue) => {
                          setDescuentoGlobalSeleccionado({
                            ...descuentoGlobalSeleccionado,
                            DescuentoGlobal: numericValue,
                          });
                        }}
                      />
                    </InputContainer>

                    {descuentoGlobalSeleccionado.TipoDescuentoGlobal && descuentoGlobalSeleccionado.DescuentoGlobal > 0 && (
                      <InputContainer>
                        <AnimatedIconButton
                          size="38px"
                          height="20px"
                          width="20px"
                          iconName="create"
                          message="Agregar"
                          onClick={handleAgregarDescuentoClick}
                        />
                      </InputContainer>
                    )}
                  </SectionRow>
                )}
              </EditSection>
            )}

            <br />
            <hr />
            <EditSection title="Detalles Item">
              <SectionRow triple={true}>
                {!isReadonly && (
                  <InputContainer label="Item">
                    <ItemLookup
                      key={itemLookupKey}
                      isMultiselect={false}
                      initialValue={itemSeleccionado}
                      onChange={(item) => {
                        setItemSeleccionado(item);
                      }}
                    />
                  </InputContainer>
                )}

                {itemSeleccionado && itemSeleccionado.value && (
                  <InputContainer label="Cantidad">
                    <Form.Control
                      type="number"
                      name="Cantidad"
                      placeholder="Precio Cantidad"
                      value={itemSeleccionado.Cantidad ?? 1}
                      onChange={(e) => {
                        setItemSeleccionado({
                          ...itemSeleccionado,
                          Cantidad: e.target.value
                        });
                      }}
                    />
                  </InputContainer>
                )}
              </SectionRow>

              {itemSeleccionado && itemSeleccionado.value && (
                <SectionRow triple={true}>
                  <InputContainer label="Precio unitario">
                    <CurrencyInput
                      name="PrecioUnitario"
                      placeholder="Precio Unitario"
                      value={itemSeleccionado.PrecioUnitario || 0}
                      onChange={(numericValue) => {
                        setItemSeleccionado({
                          ...itemSeleccionado,
                          PrecioUnitario: numericValue,
                        });
                      }}
                    />
                  </InputContainer>

                  <InputContainer>
                    <AnimatedIconButton
                      size="38px"
                      height="20px"
                      width="20px"
                      iconName="create"
                      message="Agregar"
                      onClick={handleAgregarItemClick}
                    />
                  </InputContainer>
                </SectionRow>
              )}

              <GridView
                pagination={pagination}
                setPagination={setPagination}
                dataSource={detalles}
                hideFilters={true}
                height="auto"
              >
                <GridView.Column
                  isField
                  width="100px"
                  showClearFilter={true}
                  bodyRenderer={(row) => {
                    const index = detalles.findIndex(item => item === row);
                    const count = row.SubDescuentos?.length || 0;
                    return (
                      <>
                        {!isReadonly && (
                          <div className="float-right">
                            <IconButton
                              onClick={() => {
                                const indiceEncontrado = detalles.findIndex(item => item === row);
                                handleEliminarDetalle(indiceEncontrado);
                              }}
                            >
                              <ToolTip message="Eliminar">
                                <div>
                                  <SvgComponent
                                    iconName="trash"
                                    height="25"
                                    width="25"
                                  />
                                </div>
                              </ToolTip>
                            </IconButton>
                          </div>
                        )}

                        {(!isReadonly || count > 0) && (
                          <div className="float-right">
                            <div onClick={() => handleAbrirSubDescuentoModal(index)} style={{ cursor: "pointer" }}>
                              <ToolTip message={"Descuento detallado"}>
                                <div style={{ position: "relative" }}>
                                  <SvgComponent
                                    iconName="descuento"
                                    height="25"
                                    width="25"
                                  />
                                  {count > 0 && (
                                    <span style={{
                                      position: "absolute", top: "0px", right: "-5px",
                                      background: "red", color: "white", borderRadius: "50%",
                                      fontSize: "10px", width: "16px", height: "16px",
                                      display: "flex", alignItems: "center", justifyContent: "center",
                                    }}>
                                      {count}
                                    </span>
                                  )}
                                </div>
                              </ToolTip>
                            </div>
                          </div>
                        )}
                      </>
                    );
                  }}
                />
                <GridView.Column
                  headerText="#"
                  width="50px"
                  bodyRenderer={(row) => (
                    <div style={{ textAlign: 'center' }}>
                      {detalles.findIndex(item => item === row) + 1}
                    </div>
                  )}
                />
                <GridView.Column
                  headerText="Nombre"
                  dataField="Nombre"
                />
                <GridView.Column
                  headerText="Tasa ITBIS"
                  bodyRenderer={(row) => {
                    const index = detalles.findIndex(item => item === row);
                    return (
                      <div style={{ textAlign: 'left', paddingLeft: '8px', width: '180px' }}>
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          isDisabled={isReadonly}
                          name="IndicadorFacturacion"
                          options={eCF.INDICADORES_FACTURACION}
                          value={eCF.INDICADORES_FACTURACION.find(opt => opt.value === row.IndicadorFacturacion)}
                          onChange={(selectedOption) => {
                            const event = {
                              target: {
                                name: "IndicadorFacturacion",
                                value: selectedOption ? selectedOption.value : "",
                              }
                            };
                            handleDetalleChange(index, event);
                          }}
                          menuPortalTarget={document.body}
                          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        />
                      </div>
                    );
                  }}
                />
                <GridView.Column
                  headerText="Bien o Servicio"
                  bodyRenderer={(row) => {
                    const index = detalles.findIndex(item => item === row);
                    return (
                      <div style={{ textAlign: 'left', paddingLeft: '8px', width: '150px' }}>
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          isDisabled={isReadonly}
                          name="IndicadorBienOServicio"
                          options={eCF.INDICADOR_BIEN_SERVICIO}
                          value={eCF.INDICADOR_BIEN_SERVICIO.find(opt => opt.value === row.IndicadorBienOServicio)}
                          onChange={(selectedOption) => {
                            handleDetalleChange(index, {
                              target: {
                                name: "IndicadorBienOServicio",
                                value: selectedOption ? selectedOption.value : "",
                              }
                            });
                          }}
                          menuPortalTarget={document.body}
                          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        />
                      </div>
                    );
                  }}
                />
                <GridView.Column
                  headerText="Precio Unitario"
                  bodyRenderer={(row) => {
                    const index = detalles.findIndex(item => item === row);
                    return (
                      <CurrencyInput
                        name="PrecioUnitario"
                        value={row.PrecioUnitario || 0}
                        onChange={(numericValue) =>
                          handleDetalleChange(index, { target: { name: "PrecioUnitario", value: numericValue } })
                        }
                      />
                    );
                  }}
                />
                <GridView.Column
                  headerText="Cantidad"
                  bodyRenderer={(row) => {
                    const index = detalles.findIndex(item => item === row);
                    return (
                      <div style={{ textAlign: 'left', paddingLeft: '8px' }}>
                        <Form.Control
                          type="number"
                          name="Cantidad"
                          value={row.Cantidad}
                          onChange={(event) => handleDetalleChange(index, event)}
                          style={{ maxWidth: '110px' }}
                          min="1"
                        />
                      </div>
                    );
                  }}
                />
                <GridView.Column
                  headerText="Retencion itbis"
                  bodyRenderer={(row) => {
                    const index = detalles.findIndex(item => item === row);
                    return (
                      <CurrencyInput
                        readOnly={transaccion.TipoeCF == TIPO_COMPROBANTE_PAGOS_EXTERIOR}
                        name="MontoITBISRetenido"
                        value={row.MontoITBISRetenido || 0}
                        onChange={(numericValue) =>
                          handleDetalleChange(index, { target: { name: "MontoITBISRetenido", value: numericValue } })
                        }
                      />
                    );
                  }}
                />
                <GridView.Column
                  headerText="Retencion Isr"
                  bodyRenderer={(row) => {
                    const index = detalles.findIndex(item => item === row);
                    return (
                      <CurrencyInput
                        name="MontoISRRetenido"
                        value={row.MontoISRRetenido || 0}
                        onChange={(numericValue) =>
                          handleDetalleChange(index, { target: { name: "MontoISRRetenido", value: numericValue } })
                        }
                      />
                    );
                  }}
                />
                {transaccion.DescuentoGlobalODetallado === 2 && (
                  <GridView.Column
                    headerText="Descuento Detallado"
                    bodyRenderer={(row) => {
                      const index = detalles.findIndex(item => item === row);
                      return (
                        <div style={{ textAlign: 'left', paddingLeft: '8px' }}>
                          <Form.Control
                            type="number"
                            name="DescuentoDetallado"
                            value={row.DescuentoDetallado || 0}
                            onChange={(event) => handleDetalleChange(index, event)}
                            style={{ maxWidth: '110px' }}
                            min="0"
                            step="0.01"
                          />
                        </div>
                      );
                    }}
                  />
                )}
              </GridView>

            </EditSection>

            {detalles.length > 0 && (
              <EditSection title="Detalles de los montos">
                {detalles.some(item => item.IndicadorFacturacion === 0) && (
                  <SectionRow triple={true}>
                    <InputContainer stacked label="Monto no facturable">
                      <Form.Control
                        type="text"
                        readOnly
                        value={
                          detalles.length > 0
                            ? detalles
                              .filter(item => item.IndicadorFacturacion === 0)
                              .reduce(
                                (acc, item) =>
                                  acc + ((item.PrecioUnitario || 0) * (item.Cantidad || 0)),
                                0
                              ).toLocaleString('es-DO', { minimumFractionDigits: 2 })
                            : "0.00"
                        }
                        style={{ maxWidth: '150px', backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                        tabIndex={-1}
                      />
                    </InputContainer>
                  </SectionRow>
                )}
                {detalles.some(item => item.IndicadorFacturacion === 1) && (
                  <SectionRow triple={true}>
                    <InputContainer stacked label="Monto sin impuestos para ITBIS 18%">
                      <Form.Control
                        type="text"
                        readOnly
                        value={
                          detalles.length > 0
                            ? detalles
                              .filter(item => item.IndicadorFacturacion === 1)
                              .reduce(
                                (acc, item) =>
                                  acc + ((item.PrecioUnitario || 0) * (item.Cantidad || 0)),
                                0
                              ).toLocaleString('es-DO', { minimumFractionDigits: 2 })
                            : "0.00"
                        }
                        style={{ maxWidth: '150px', backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                        tabIndex={-1}
                      />
                    </InputContainer>
                    <InputContainer stacked label="Impuesto ITBIS 18%">
                      <Form.Control
                        type="text"
                        readOnly
                        value={
                          detalles.length > 0
                            ? detalles
                              .filter(item => item.IndicadorFacturacion === 1)
                              .reduce(
                                (acc, item) =>
                                  acc + ((item.PrecioUnitario || 0) * (item.Cantidad
                                    || 0) * 0.18),
                                0
                              ).toLocaleString('es-DO', { minimumFractionDigits: 2 })
                            : "0.00"
                        }
                        style={{
                          maxWidth: '150px', backgroundColor: '#f8f9fa', fontWeight: 'bold'
                        }}
                        tabIndex={- 1
                        }
                      />
                    </InputContainer>
                    <InputContainer stacked label="Subtotal con ITBIS 18%">
                      <Form.Control
                        type="text"
                        readOnly
                        value={
                          detalles.length > 0
                            ? detalles
                              .filter(item => item.IndicadorFacturacion === 1)
                              .reduce(
                                (acc, item) =>
                                  acc + ((item.PrecioUnitario || 0) * (item.Cantidad || 0) * 1.18),
                                0
                              ).toLocaleString('es-DO', { minimumFractionDigits: 2 })
                            : "0.00"
                        }
                        style={{ maxWidth: '150px', backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                        tabIndex={-1}
                      />
                    </InputContainer>
                  </SectionRow>
                )}

                {detalles.some(item => item.IndicadorFacturacion === 2) && (
                  <SectionRow triple={true}>
                    <InputContainer stacked label="Monto sin impuestos para ITBIS 16%">
                      <Form.Control
                        type="text"
                        readOnly
                        value={
                          detalles.length > 0
                            ? detalles
                              .filter(item => item.IndicadorFacturacion === 2)
                              .reduce(
                                (acc, item) =>
                                  acc + ((item.PrecioUnitario || 0) * (item.Cantidad || 0)),
                                0
                              ).toLocaleString('es-DO', { minimumFractionDigits: 2 })
                            : "0.00"
                        }
                        style={{ maxWidth: '150px', backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                        tabIndex={-1}
                      />
                    </InputContainer>

                    <InputContainer stacked label="Impuesto ITBIS 16%">
                      <Form.Control
                        type="text"
                        readOnly
                        value={
                          detalles.length > 0
                            ? detalles
                              .filter(item => item.IndicadorFacturacion === 2)
                              .reduce(
                                (acc, item) =>
                                  acc + ((item.PrecioUnitario || 0) * (item.Cantidad
                                    || 0) * 0.16),
                                0
                              ).toLocaleString('es-DO', { minimumFractionDigits: 2 })
                            : "0.00"
                        }
                        style={{
                          maxWidth: '150px', backgroundColor: '#f8f9fa', fontWeight: 'bold'
                        }}
                        tabIndex={- 1
                        }
                      />
                    </InputContainer>

                    <InputContainer stacked label="Subtotal con ITBIS 16%">
                      <Form.Control
                        type="text"
                        readOnly
                        value={
                          detalles.length > 0
                            ? detalles
                              .filter(item => item.IndicadorFacturacion === 2)
                              .reduce(
                                (acc, item) =>
                                  acc + ((item.PrecioUnitario || 0) * (item.Cantidad || 0) * 1.16),
                                0
                              ).toLocaleString('es-DO', { minimumFractionDigits: 2 })
                            : "0.00"
                        }
                        style={{ maxWidth: '150px', backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                        tabIndex={-1}
                      />
                    </InputContainer>
                  </SectionRow>
                )}

                {detalles.some(item => item.IndicadorFacturacion === 3) && (
                  <SectionRow triple={true}>
                    <InputContainer stacked label="Monto ITBIS 0%">
                      <Form.Control
                        type="text"
                        readOnly
                        value={
                          detalles.length > 0
                            ? detalles
                              .filter(item => item.IndicadorFacturacion === 3)
                              .reduce(
                                (acc, item) =>
                                  acc + ((item.PrecioUnitario || 0) * (item.Cantidad || 0)),
                                0
                              ).toLocaleString('es-DO', { minimumFractionDigits: 2 })
                            : "0.00"
                        }
                        style={{ maxWidth: '150px', backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                        tabIndex={-1}
                      />
                    </InputContainer>

                    <InputContainer stacked label="Impuesto ITBIS 0%">
                      <Form.Control
                        type="text"
                        readOnly
                        value={
                          detalles.length > 0
                            ? detalles
                              .filter(item => item.IndicadorFacturacion === 3)
                              .reduce(
                                (acc, item) =>
                                  acc + ((item.PrecioUnitario || 0) * (item.Cantidad
                                    || 0) * 0),
                                0
                              ).toLocaleString('es-DO', { minimumFractionDigits: 2 })
                            : "0.00"
                        }
                        style={{
                          maxWidth: '150px', backgroundColor: '#f8f9fa', fontWeight: 'bold'
                        }}
                        tabIndex={- 1
                        }
                      />
                    </InputContainer>

                    <InputContainer stacked label="Subtotal con ITBIS 0%">
                      <Form.Control
                        type="text"
                        readOnly
                        value={
                          detalles.length > 0
                            ? detalles
                              .filter(item => item.IndicadorFacturacion === 3)
                              .reduce(
                                (acc, item) =>
                                  acc + ((item.PrecioUnitario || 0) * (item.Cantidad || 0)),
                                0
                              ).toLocaleString('es-DO', { minimumFractionDigits: 2 })
                            : "0.00"
                        }
                        style={{ maxWidth: '150px', backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                        tabIndex={-1}
                      />
                    </InputContainer>
                  </SectionRow>
                )}

                {detalles.some(item => item.IndicadorFacturacion === 4) && (
                  <SectionRow triple={true}>
                    <InputContainer stacked label="Monto Exento">
                      <Form.Control
                        type="text"
                        readOnly
                        value={
                          detalles.length > 0
                            ? detalles
                              .filter(item => item.IndicadorFacturacion === 4)
                              .reduce(
                                (acc, item) =>
                                  acc + ((item.PrecioUnitario || 0) * (item.Cantidad || 0)),
                                0
                              ).toLocaleString('es-DO', { minimumFractionDigits: 2 })
                            : "0.00"
                        }
                        style={{ maxWidth: '150px', backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                        tabIndex={-1}
                      />
                    </InputContainer>
                  </SectionRow>
                )}
              </EditSection>
            )}

            {detalles.length > 0 && (
              <EditSection title="Totales de los montos">
                <SectionRow triple={true}>
                  <InputContainer stacked label="Monto Total">
                    <Form.Control
                      type="text"
                      readOnly
                      value={montoTotal.toLocaleString('es-DO', { minimumFractionDigits: 2 })}
                      style={{ maxWidth: '150px', backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                      tabIndex={-1}
                    />
                  </InputContainer>
                </SectionRow>

                <SectionRow triple={true}>
                  <InputContainer stacked label="Impuesto Total aplicado">
                    <Form.Control
                      type="text"
                      readOnly
                      value={
                        detalles.length > 0
                          ? (
                            detalles.reduce(
                              (acc, item) =>
                                acc + ((item.PrecioUnitario || 0) * (item.Cantidad || 0) * (item.IndicadorFacturacion === 1 ? 1.18 : item.IndicadorFacturacion === 2 ? 1.16 : 1)),
                              0
                            )
                            -
                            detalles.reduce(
                              (acc, item) =>
                                acc + ((item.PrecioUnitario || 0) * (item.Cantidad || 0)),
                              0
                            )
                          ).toLocaleString('es-DO', { minimumFractionDigits: 2 })
                          : "0.00"
                      }
                      style={{ maxWidth: '150px', backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                      tabIndex={-1}
                    />
                  </InputContainer>
                </SectionRow>

                <SectionRow triple={true}>
                  <InputContainer stacked label="Monto Total con impuestos">
                    <Form.Control
                      type="text"
                      readOnly
                      value={
                        detalles.length > 0
                          ? detalles
                            .filter(item => item.IndicadorFacturacion !== 0)
                            .reduce(
                              (acc, item) =>
                                acc + ((item.PrecioUnitario || 0) * (item.Cantidad || 0) * (item.IndicadorFacturacion === 1 ? 1.18 : item.IndicadorFacturacion === 2 ? 1.16 : 1)),
                              0
                            ).toLocaleString('es-DO', { minimumFractionDigits: 2 })
                          : "0.00"
                      }
                      style={{ maxWidth: '150px', backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                      tabIndex={-1}
                    />
                  </InputContainer>
                </SectionRow>

                <SectionRow triple={true}>
                  <InputContainer stacked label="Total Retención ITBIS">
                    <Form.Control
                      type="text"
                      readOnly
                      value={totalITBISRetenido.toLocaleString('es-DO', { minimumFractionDigits: 2 })}
                      style={{ maxWidth: '150px', backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                      tabIndex={-1}
                    />
                  </InputContainer>
                </SectionRow>

                <SectionRow triple={true}>
                  <InputContainer stacked label="Total Retención ISR">
                    <Form.Control
                      type="text"
                      readOnly
                      value={totalISRRetenido.toLocaleString('es-DO', { minimumFractionDigits: 2 })}
                      style={{ maxWidth: '150px', backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                      tabIndex={-1}
                    />
                  </InputContainer>
                </SectionRow>

                {transaccion.DescuentoGlobal > 0 && (
                  <SectionRow triple={true}>
                    <InputContainer stacked label={`Descuento (${eCF.TIPOS_DESCUENTOS.find(o => o.value === transaccion.TipoDescuentoGlobal)?.value ?? ""})`}>
                      <Form.Control
                        type="text"
                        readOnly
                        value={parseFloat(transaccion.DescuentoGlobal || 0).toLocaleString('es-DO', { minimumFractionDigits: 2 })}
                        style={{ maxWidth: '150px', backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                        tabIndex={-1}
                      />
                    </InputContainer>
                  </SectionRow>
                )}
              </EditSection>
            )}
          </EditContainer>
        </Card>
      </Form>

      {showSubDescuentoModal && subDescuentoModal}

      <ModalContainer
        showModal={showEmailModal}
        size="lg"
        title="Enviar Representación Impresa Por Email"
        btnGrabar={{ label: "Enviar Email", show: true }}
        cerrar={() => setShowEmailModal(false)}
        grabar={() => enviarRepresentacionEmail()}
      >
        <EditSection>
          <InputContainer stacked label="Email">
            <Form.Control
              value={transaccion.CorreoComprador ?? ""}
              onChange={(e) =>
                setTransaccion({ ...transaccion, CorreoComprador: e.target.value })
              }
            />
          </InputContainer>
        </EditSection>
      </ModalContainer>

      <ModalContainer
        showModal={showCancelarModal}
        size="lg"
        title={`Nota de Cancelación Transacción: ${Id}`}
        subtitle={`NCF: ${transaccion.eNCF}`}
        btnGrabar={{ label: "Generar Nota de Cancelación", show: true }}
        cerrar={() => setShowCancelarModal(false)}
        grabar={() => cancelarECF()}
      >
        <EditSection>
          <InputContainer stacked label="Fecha de Emisión">
            <DateTimePicker
              soloFecha={true}
              usarLabel={false}
              fechaInicioOriginal={cancelacionData.fechaEmisionCancelacion}
              onChange={(e) => {
                if (e.fechaInicio != null)
                  setCancelacionData({
                    ...cancelacionData,
                    fechaEmisionCancelacion: DateHelper.formatDate(e.fechaInicio),
                  });
              }}
            />
          </InputContainer>
          <InputContainer stacked label="Tipo Nota de Cancelación">
            <Select
              className="react-select primary mb-2"
              classNamePrefix="react-select"
              isDisabled={true}
              options={TIPO_NOTAS_CANCELACION}
              value={TIPO_NOTAS_CANCELACION.filter(
                (o) => o.value === (cancelacionData.TipoNotaCancelacion ?? TIPO_NOTAS_CANCELACION[0]?.value)
              )}
              onChange={(e) =>
                setCancelacionData({ ...cancelacionData, TipoNotaCancelacion: e.value })
              }
            />
          </InputContainer>
        </EditSection>
      </ModalContainer>
    </>
  );
}

const RadioGroup = ({ options, selectedOption, onChange }) => {
  return (
    <div>
      {options.map((option) => (
        <label key={option.value} style={{ fontWeight: "none !important" }}>
          <input
            style={{ marginLeft: "5px" }}
            type="radio"
            value={option.value}
            checked={selectedOption === option.value}
            onChange={onChange}
          />
          {option.label}
        </label>
      ))}
    </div>
  )
};